export let SHARE_MODES;
(function (SHARE_MODES) {
  SHARE_MODES["CHANNEL"] = "channel";
  SHARE_MODES["VIDEO"] = "video";
})(SHARE_MODES || (SHARE_MODES = {}));
//# sourceMappingURL=constants.js.map